// extracted by mini-css-extract-plugin
export const teamContactModal = "team-contact-modal-module--teamContactModal--2rN9z";
export const contactModalFooter = "team-contact-modal-module--contactModalFooter--12em3";
export const successContainer = "team-contact-modal-module--successContainer--3_cQT";
export const successMessage = "team-contact-modal-module--successMessage--1pEea";